import React from 'react'
import Toggle from '../../Toggle'
import Button from '../../Button'

function Actions({ actions }) {
  return <div>{actions.map((props, idx) => Factory({ ...props, idx }))}</div>
}

export default Actions

const Factory = (props) => {
  const { kind, label, defaultValue, cta, idx } = props
  switch (kind) {
    case 'toggle':
      return (
        <div key={idx} className='amchart-toggle-wrapper'>
          <Toggle
            id={`chart-toggle-${idx}`}
            labelText={label}
            defaultToggled={defaultValue}
            onToggle={cta}
          />
        </div>
      )
    default:
      return (
        <Button key={idx} onClick={cta}>
          {label}
        </Button>
      )
  }
}
